import styled from "styled-components";
import zIndexTypes from "../../../../theme/zIndexTypes";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Backdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${zIndexTypes.modal};
  display: flex;
  justify-content: center;
  align-items: center;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  &.animated {
    animation-duration: 0.4s;
    animation-fill-mode: both;
  }
`;

export const Modal = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 500px;
  z-index: ${zIndexTypes.modal};
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;
  overflow: hidden;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.smallDesktop`
    margin-left: unset;
  `}

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 20px);
    position: absolute;
    top: 10px;
  `}
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const Body = styled.div`
  padding: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 340px;
  justify-content: space-around;
`;

export const Text = styled.p`
  width: 320px;
  font-size: 0.95em;

  ${mediaMaxWidth.phone`
    width: calc(100vw - 80px);
    text-align: justify;
  `}
`;

export const CopyButton = styled.button`
  color: #79D9D9;
  cursor: pointer;
  background: none;
  border: none;
  font-weight: 700;
  display: flex;
  align-items: center;
  padding: 10px 0;
  font-size: 1.1em;
  position: relative;

  svg {
    margin-left: 15px;
    font-size: 1.3em;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    color: #402680;
  }

  &:active,
  &:visited {
    color: #79D9D9;
  }
`;

export const Copied = styled.div`
  position: absolute;
  bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #222;
  padding: 7px 5px;
  font-size: 0.7em;
  color: #fff;
  border-radius: 8px;
  right: 0;
  left: 0;
  width: 170px;
  margin: 0 auto;
  font-weight: 400;
  transition: 0.2s all;

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInUp {
    animation-name: fadeInUp;
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  svg {
    margin-left: 7px;
    font-size: 0.9em;
  }
`;

export const ArrowDown = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #222;
  opacity: 0.9;
  position: absolute;
  bottom: -5px;
`;
